import { computed, inject, Injectable, resource } from '@angular/core';
import { DeliveryNoteRosterArtifactsRepository } from '../repositories/delivery-note-roster-artifacts.repository';

@Injectable({ providedIn: 'root' })
export class DeliveryNoteRosterArtifactsService {
  private readonly repository = inject(DeliveryNoteRosterArtifactsRepository);

  readonly ordersResource = resource({
    loader: async () => {
      try {
        return await this.repository.loadOrders();
      } catch {
        return [];
      }
    },
  });

  readonly purchaseOrdersResource = resource({
    loader: async () => {
      try {
        return await this.repository.loadPurchaseOrders();
      } catch {
        return [];
      }
    },
  });

  readonly orders = computed(() => this.ordersResource.value() ?? []);
  readonly purchaseOrders = computed(() => this.purchaseOrdersResource.value() ?? []);

  readonly ordersLoading = computed(() => this.ordersResource.isLoading());
  readonly purchaseOrdersLoading = computed(() => this.purchaseOrdersResource.isLoading());

  reloadOrders(): void {
    this.ordersResource.reload();
  }

  reloadPurchaseOrders(): void {
    this.purchaseOrdersResource.reload();
  }
}
